














































import { Component, Vue, Prop } from "vue-property-decorator";
import { dictionaryData } from "./maituData";
@Component({})
export default class MaituZidian extends Vue {
  private data: any = {};
  private currentPart: any = "脉图时域绝对值";
  private mounted() {
    this.data = dictionaryData;
  }
}
